/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniBackward = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-backward ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M7.71178 4.81859C8.71111 4.20135 10 4.9202 10 6.09478V9.06757C10.1044 8.93643 10.234 8.81954 10.389 8.72382L16.7118 4.81859C17.7111 4.20135 19 4.9202 19 6.09478V13.9053C19 15.0798 17.7111 15.7987 16.7118 15.1815L10.389 11.2762C10.234 11.1805 10.1044 11.0636 10 10.9325V13.9053C10 15.0798 8.71111 15.7987 7.71178 15.1815L1.38901 11.2762C0.439994 10.6901 0.439991 9.30998 1.38901 8.72382L7.71178 4.81859Z"
        fill="#7041F1"
      />
    </svg>
  );
};
